import { render, staticRenderFns } from "./PaymentDetailDialog.vue?vue&type=template&id=bc44aac4&scoped=true&"
import script from "./PaymentDetailDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailDialog.vue?vue&type=style&index=0&id=bc44aac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc44aac4",
  null
  
)

export default component.exports